import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {TagSchema} from 'constants/RegistryConstants';
import {SchemaTag, Tag} from 'folder-items/FileConstants';
import SchemaTagTableSchemaSelector from 'metadata/SchemaTagTableSchemaSelector';
import TagTable from 'metadata/TagTable';
import {TagTableErrorsByFieldId} from 'metadata/useTagTableState';
import {SelectTemplateFromTemplateCollectionsQuery} from 'notebook/entry-templates/SelectTemplateCollectionItemTree/__generated/SelectTemplateFromTemplateCollectionsQuery';
import * as ComputedTagUtil from 'schemas/tags/computed/ComputedTagUtil';
import * as IntegrationTagUtil from 'schemas/tags/integration/IntegrationTagUtil';
import {getTagTableFriendlyTags} from 'schemas/tags/TagUtil';
import {StudyAssociationInputProps} from 'studies/StudyAssociationInput';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

export type SelectTemplateCollectionItemTreeTemplate = Pick<
  SelectTemplateFromTemplateCollectionsQuery['templateCollections'][number]['children'][number],
  'id' | 'name'
>;

export interface CreateEntryFromTemplateModalContentsProps {
  isTemplateSelectorDisabled: boolean;
  templateId: string | null;
  changeTemplate: (template: SelectTemplateCollectionItemTreeTemplate | null) => void;
  initialDay: string;
  setInitialDay: (day: string) => void;
  entryName: string;
  setEntryName: (name: string) => void;
  folderId: string | null | undefined;
  setFolderId: (folderId: string) => void;
  folderFieldLabel?: string;
  queryIsPending: boolean;
  canChangeSchema: () => boolean;
  schemaTags: Array<SchemaTag>;
  tagSchema: TagSchema | null;
  updateTagSchema: (newTagSchema: TagSchema | null, initialTags?: Array<SchemaTag>) => void;
  updateSchemaTag: (tagIndex: number, newValue: Tag) => void;
  errorsByFieldId: TagTableErrorsByFieldId;
  filterTemplateIds?: Array<string>;
  showUnpublishedCollectibles?: boolean;
  studyAssociationInputProps?: StudyAssociationInputProps;
  enableAutoLinkingSelection?: boolean;
}

export const renderTagTable = (props: CreateEntryFromTemplateModalContentsProps): JSX.Element =>
  props.queryIsPending ? (
    <CenteredHorizontalThrobber />
  ) : (
    <TagTable
      canRefreshTags={
        ComputedTagUtil.hasComputedTags(getTagTableFriendlyTags(props.schemaTags)) ||
        IntegrationTagUtil.hasIntegrationTags(getTagTableFriendlyTags(props.schemaTags))
      }
      emptyMessage="This schema has no fields."
      errorsByFieldId={props.errorsByFieldId}
      tags={props.schemaTags}
      areTagsEditable={false}
      isLoadingTags={false}
      sequenceParts={null}
      subheaderNode={
        <SchemaTagTableSchemaSelector
          fileType={ModelTypeConstants.ENTRY}
          isSchemaEditable={props.canChangeSchema()}
          isFileRegistered={false}
          onUpdateTagSchema={props.updateTagSchema}
          tagSchema={props.tagSchema}
        />
      }
      title={<div>Schema</div>}
      onUpdateTag={props.updateSchemaTag}
      isEditing={true}
    />
  );
